import { ReactNode } from 'react'

import { TabsContextProvider } from './TabsContext'

export type TabsProps = {
  children: ReactNode
  defaultValue?: string
  onChange?: (tab: string) => void
}

export const TabsComponent = ({ children, defaultValue, onChange }: TabsProps) => (
  <TabsContextProvider defaultValue={defaultValue} onChange={onChange}>
    {children}
  </TabsContextProvider>
)
